<template>
  <div>
    <h1 class="page-title text-left">No Spray</h1>
    <div class="panel">
      <div class="panel-heading">
        <h3 class="panel-title">
          Details
          <router-link :to="{ name: 'data-no-spray' }" class="pull-right ml-10"><i class="fa fa-list"></i></router-link>
          <i class="fa fa-pencil pointer pull-right" v-on:click="form.showEdit({id: id, list: true})"></i>
        </h3>
      </div>
      <div class="panel-body">
        <dl class="dl-horizontal">
          <dt>Active</dt>
          <dd><i class="fa" :class="{ 'fa-check-square-o': form.data.isActive, 'fa-square-o': !form.data.isActive}"></i></dd>

          <dt>Contract</dt>
          <dd>{{ contractName(form.data.contractId) }}</dd>

          <dt>Request Type</dt>
          <dd>{{ requestTypeName(form.data.requestTypeId) }}</dd>

          <dt>Contact</dt>
          <dd>
            {{ form.data.firstName }} {{ form.data.lastName }}<br>
            <i class="fa fa-envelope"></i> {{ form.data.email }}<br>
            <i class="fa fa-envelope"></i> {{ form.data.email2 }}<br>
            <i class="fa fa-phone"></i> {{ form.data.phone }}<br>
            <i class="fa fa-phone"></i> {{ form.data.altPhone }}
          </dd>

          <dt>Address</dt>
          <dd class="pointer" v-on:click="showMap(`${form.data.address}, ${form.data.city} ${stateName(form.data.stateId)} ${form.data.zip} `)">
            <i class="fa fa-map"></i>
            {{ form.data.address }}<br>
            {{ form.data.city }}, {{ stateName(form.data.stateId) }} {{ form.data.zip }}
            <br>
            <span v-if="form.data.addressMailing">Mailing: {{ form.data.addressMailing }}</span>

          </dd>

          <dt>Reason</dt>
          <dd>{{ form.data.reason }}</dd>

          <dt>County</dt>
          <dd>{{ countyName(form.data.countyId) }}</dd>

          <dt>Zone</dt>
          <dd>{{ zoneName(form.data.zoneId) }}</dd>

          <dt>Spray Route</dt>
          <dd>{{ routeName(form.data.routeId) }}</dd>

          <dt>Municipality</dt>
          <dd>{{ municipalityName(form.data.municipalityId) }}</dd>

          <dt>Subdivision</dt>
          <dd>{{ subdivisionName(form.data.subdivisionId) }}</dd>

          <dt>Year Renewed</dt>
          <dd>{{ form.data.yearRenewed }}</dd>

          <dt>Uses Custom Geofence</dt>
          <dd><i class="fa" :class="{ 'fa-check-square-o': form.data.usesCustomGeofence, 'fa-square-o': !form.data.usesCustomGeofence}"></i></dd>

          <dt>Coordinates</dt>
          <dd class="pointer" v-on:click="showMap({lat: form.data.latitude, lon: form.data.longitude})">
            <i class="fa fa-map"></i> {{ form.data.latitude }}, {{ form.data.longitude}}
          </dd>

          <dt>Custom Geofence</dt>
          <dd v-if="form.data.customGeofenceCoordinates !== null" class="pointer" v-on:click="showMap(form.data.customGeofenceCoordinates)">
            <i class="fa fa-map"></i> {{ form.data.customGeofenceCoordinates.length }} points
          </dd>

          <dt>Near Zone 1</dt>
          <dd>{{ form.data.nearZone1 }}</dd>

          <dt>Near Zone 2</dt>
          <dd>{{ form.data.nearZone2 }}</dd>

          <dt>Near Zone 3</dt>
          <dd>{{ form.data.nearZone3 }}</dd>

          <dt>Fog</dt>
          <dd>{{ form.data.fog }}</dd>

          <dt>Deactivated Date</dt>
          <dd>{{ form.data.deactivatedDate | date }}</dd>

          <dt>Deactivated Comment</dt>
          <dd>{{ form.data.deactivatedComment }}</dd>

          <dt>Comments</dt>
          <dd>{{ form.data.notes }}</dd>



        </dl>
      </div>
    </div>

    <site-form :form="form" ></site-form>

    <google-map ref="gmap"></google-map>

  </div>
</template>

<script>
  import NoSprayService from '@/services/NoSprayService';
  import Form from '@/utils/form';
  import loader from '@/utils/loader';
  import siteForm from '@/components/forms/no_spray';
  import googleMap from '@/components/googleMap';

  import store from '@/store';

  export default {
    name: 'no_spray_details',

    components: {
      siteForm,
      googleMap
    },

    props: ['id'],

    data() {
      return {
        form: new Form(
          NoSprayService,
          {
          })
      }
    },

    methods: {
      contractName(id) {
        return this.$store.getters.contractNameById(id);
      },
      routeName(id) {
        return this.$store.getters.routeNameById(id);
      },
      countyName(id) {
        return this.$store.getters.countyNameById(id);
      },
      municipalityName(id) {
        return this.$store.getters.municipalityNameById(id);
      },
      requestTypeName(id) {
        return this.$store.getters.requestTypeNameById(id);
      },
      subdivisionName(id) {
        return this.$store.getters.subdivisionNameById(id);
      },
      stateName(id) {
        return this.$store.getters.stateNameById(id);
      },
      zoneName(id) {
        return this.$store.getters.zoneNameById(id);
      },
      showMap(coordinates) {
        this.$refs.gmap.showMap(coordinates);
      }
    },

    mounted() {

      loader.lookups()
        .then(() => {
          this.form.getDetails(this.id);
        });
    }

  }
</script>

<style lang="scss">

</style>
